import { BoxProps } from '@jfs/ui-new'
import { Dimensions, ImageStyle } from 'react-native'
import { CarousalDimens, ListDimens } from '../../utils/utils'
import { TextProps } from '../TextNew'
import { CarousalDotSize } from './types'

const { width, height } = Dimensions.get('screen')
const defaultStyles = {
  container: { alignItems: 'center' } as BoxProps,
  flatListStyle: { flexGrow: 0 } as BoxProps,
  carouselDots: (selected: boolean) =>
    ({
      height: ListDimens.LIST_CAROUSEL_DOTS_SIZE,
      width: ListDimens.LIST_CAROUSEL_DOTS_SIZE,
      backgroundColor: selected ? 'PRIMARY_GREY' : 'BORDER_COLOR',
      margin: ListDimens.LIST_CAROUSEL_DOTS_MARGIN,
      borderRadius: ListDimens.LIST_CAROUSEL_DOTS_BORDER_RADIUS,
    } as BoxProps),
  itemContainer: () => ({} as BoxProps),
  imageStyle: {} as ImageStyle,
  dotContainer: {
    width: 140,
    alignItems: 'center',
  } as BoxProps,
  singleDotContainer: {
    height: 20,
    width: CarousalDimens.CAROUSAL_DOT_CONTAINER_WIDTH,
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  closeBtn: {
    position: 'absolute',
    top: 70,
    right: 10,
    zIndex: 2,
  } as BoxProps,
  textStyle: () => ({} as TextProps),
  underlayColor: () => 'TRANSPARENT',
}

export const fullScreenStyles = {
  width,
  height,
  zIndex: 20,
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  position: 'absolute',
  backgroundColor: 'BLACK',
  justifyContent: 'center',
  alignItems: 'center',
} as BoxProps

const styles = {
  bigWithDots: {
    ...defaultStyles,
    carouselDots: (selected: boolean, size: CarousalDotSize) =>
      ({
        height: size,
        width: size,
        backgroundColor: selected ? 'HOTEL_PRIMARY' : 'HOTEL_PRIMARY_TRANSPARENT',
        marginVertical: ListDimens.LIST_CAROUSEL_DOTS_MARGIN,
        marginHorizontal: ListDimens.LIST_CAROUSEL_DOTS_MARGIN / 2,
        borderRadius: size / 2,
      } as BoxProps),
    imageStyle: {
      width: width - 32,
      borderRadius: CarousalDimens.CAROUSAL_BORDER_RADIUS,
      height: CarousalDimens.CAROUSAL_FULL_HEIGHT,
    } as ImageStyle,
    itemContainer: () =>
      ({
        backgroundColor: 'WHITE',
        shadowColor: 'BLACK',
        shadowOffset: {
          width: 0,
          height: 1,
        },
        shadowOpacity: 0.2,
        shadowRadius: 4,
        elevation: 2,
        margin: CarousalDimens.CAROUSAL_FULL_MARGIN,
        height: CarousalDimens.CAROUSAL_FULL_HEIGHT,
      } as BoxProps),
  },
  childAge: {
    ...defaultStyles,
    container: { width: CarousalDimens.CAROUSAL_AGE_CONTAINER_SIZE, alignItems: 'center' } as BoxProps,
    itemContainer: (isSelected: boolean) =>
      ({
        height: CarousalDimens.CAROUSAL_AGE_SIZE,
        width: CarousalDimens.CAROUSAL_AGE_SIZE,
        backgroundColor: isSelected ? 'PRIMARY' : 'WHITE',
        borderRadius: 4,
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: CarousalDimens.CAROUSAL_AGE_MARGIN_HORIZONTAL,
      } as BoxProps),
    textStyle: (isSelected: boolean) =>
      ({
        color: isSelected ? 'WHITE' : 'DARK_GREY',
        fontSize: 'FONT_SIZE_MEDIUM',
        fontWeight: isSelected ? 'FONT_WEIGHT_BOLD' : 'FONT_WEIGHT_MEDIUM',
      } as TextProps),
    underlayColor: (isSelected: boolean) => (isSelected ? 'PRIMARY' : 'TRANSPARENT'),
  },
  hotelDetail: {
    ...defaultStyles,
    container: {
      height: CarousalDimens.CAROUSAL_ROOM_HEIGHT,
      alignItems: 'center',
      backgroundColor: 'BLUE_SHADE',
    } as BoxProps,
    dotContainer: {
      position: 'absolute',
      bottom: CarousalDimens.CAROUSAL_ROOM_DOTS_CONTAINER_BOTTOM,
      width: 140,
      alignItems: 'center',
    } as BoxProps,
    carouselDots: (selected: boolean, size: CarousalDotSize) =>
      ({
        height: size,
        width: size,
        backgroundColor: selected ? 'WHITE' : 'WHITE30',
        margin: ListDimens.LIST_CAROUSEL_DOTS_MARGIN,
        borderRadius: size / 2,
      } as BoxProps),
  },
  roomType: {
    ...defaultStyles,
    carouselDots: (selected: boolean, size: CarousalDotSize) =>
      ({
        height: size,
        width: size,
        backgroundColor: selected ? 'DARK_GREY' : 'GREY_1_SEPARATOR',
        marginLeft: ListDimens.LIST_CAROUSEL_DOTS_MARGIN,
        marginRight: ListDimens.LIST_CAROUSEL_DOTS_MARGIN,
        borderRadius: size / 2,
      } as BoxProps),
  },
  hotelFilter: {
    ...defaultStyles,
    flatListStyle: { flexGrow: 0, alignSelf: 'stretch' } as BoxProps,
    container: { width: '100%', alignItems: 'flex-start' } as BoxProps,
    itemContainer: (isSelected: boolean) =>
      ({
        backgroundColor: isSelected ? 'PRIMARY' : 'LIGHT_GREY',
        height: 20,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: 8,
        marginHorizontal: 8,
      } as BoxProps),
    textStyle: (isSelected: boolean) =>
      ({
        color: isSelected ? 'WHITE' : 'BLACK',
        fontSize: 10,
        fontWeight: 'FONT_WEIGHT_LIGHT',
      } as TextProps),
    underlayColor: (isSelected: boolean) => (isSelected ? 'PRIMARY' : 'LIGHT_GREY'),
  },
}

export const showDots = {
  bigWithDots: true,
  childAge: false,
  hotelDetail: true,
  roomType: true,
  hotelFilter: false,
}

export const carousalItemWidth = {
  bigWithDots: width - 24,
  childAge: CarousalDimens.CAROUSAL_AGE_SIZE_WITH_MARGIN,
  hotelDetail: width,
  roomType: width,
  hotelFilter: 'auto',
}

export const offSetAdjustment = {
  bigWithDots: 12,
  childAge: 0,
  hotelDetail: 0,
  roomType: 0,
  hotelFilter: 0,
}

export const selectedOffset = {
  bigWithDots: 0,
  childAge: 2,
  hotelDetail: 0,
  roomType: 0,
  hotelFilter: 0,
}
export const initialSelected = {
  bigWithDots: 0,
  childAge: 2,
  hotelDetail: 0,
  roomType: 0,
  hotelFilter: -1,
}

export default styles
